var ShippingCalculator = {
    cart: null,
    shop: {
        currency: '{{ shop.currency }}'
    },
    selectors: {
        wrapper: document.querySelector('.js-shipping-calculator'),
        buttonsZip: document.querySelectorAll('.js-button'),
        fieldsZip: document.querySelectorAll('.js-zip'),
        wrapperResponse: document.querySelector('.shipping__response')
    },
    init: function(){

        this.selectors.wrapper = document.querySelector('.js-shipping-calculator');
        this.selectors.buttonsZip = document.querySelectorAll('.js-button');
        this.selectors.fieldsZip = document.querySelectorAll('.js-zip');
        this.selectors.wrapperResponse = document.querySelector('.shipping__response');

        this.selectors.fieldsZip.forEach((item) => {
            item.addEventListener('keyup', (event) => {
                if(event.keyCode == 13) {
                    event.preventDefault();

                    const form = event.currentTarget.closest('.shipping__form');
                    this.selectors.wrapper = event.currentTarget.closest('.js-shipping-calculator');
                    this.selectors.wrapperResponse = this.selectors.wrapper.querySelector('.shipping__response');

                    ShippingCalculator.checkZip(form);
                }
            }); 
            item.addEventListener('focus', (event) => {
                if(event.currentTarget.value.length === 0){
                    this.renderReponse('');
                }
            });
        });

        this.selectors.buttonsZip.forEach((item) => {
            item.addEventListener('click', (event) => {
                const form = event.currentTarget.closest('.shipping__form');
                this.selectors.wrapper = event.currentTarget.closest('.js-shipping-calculator');
                this.selectors.wrapperResponse = this.selectors.wrapper.querySelector('.shipping__response');

                ShippingCalculator.checkZip(form);
            });
        });
    },
    checkZip: async function(form){
        this.renderReponse('');
        this.showLoading(true);

        var shipping = {
            zip: form.querySelector('.form__zip').value
        }

        if(shipping.zip.length != 9) {
            this.showLoading(false);
            this.renderReponse('Digite um CEP válido.');
        }else {
            const cart = await this.getCart();
            this.cart = cart;
            
            if(cart.item_count === 0){
                const variant_id = document.querySelector('input[name=variant_id]').value;
                await this.addItemCart(variant_id);
                this.getShippingRates(shipping.zip, true);
            } else {
                this.getShippingRates(shipping.zip);
            }
        }			

    },
    getZip: async function(zip){
        let zipInfo;
        const url = `//viacep.com.br/ws/${ zip }/json`;

        await fetch(url).then( response => response.json() ).then( response => {
            let state;
            switch (response.uf) {
                case "AC" :	state = "Acre";					break;
                case "AL" :	state = "Alagoas";				break;
                case "AM" :	state = "Amazonas";				break;
                case "AP" :	state = "Amapá";				break;
                case "BA" :	state = "Bahia";				break;
                case "CE" :	state = "Ceará";				break;
                case "DF" :	state = "Distrito Federal";		break;
                case "ES" :	state = "Espírito Santo";		break;
                case "GO" :	state = "Goiás";				break;
                case "MA" :	state = "Maranhão";				break;
                case "MG" :	state = "Minas Gerais";			break;
                case "MS" :	state = "Mato Grosso do Sul";	break;
                case "MT" :	state = "Mato Grosso";			break;
                case "PA" :	state = "Pará";					break;
                case "PB" :	state = "Paraíba";				break;
                case "PE" :	state = "Pernambuco";			break;
                case "PI" :	state = "Piauí";				break;
                case "PR" :	state = "Paraná";				break;
                case "RJ" :	state = "Rio de Janeiro";		break;
                case "RN" :	state = "Rio Grande do Norte";	break;
                case "RO" :	state = "Rondônia";				break;
                case "RR" :	state = "Roraima";				break;
                case "RS" :	state = "Rio Grande do Sul";	break;
                case "SC" :	state = "Santa Catarina";		break;
                case "SE" :	state = "Sergipe";				break;
                case "SP" :	state = "São Paulo";			break;
                case "TO" :	state = "Tocantíns";			break;
            } 		
            response.state = state;
            zipInfo = response;
            
        }).catch(error => {
            console.error('Error:', error);
        });
        return zipInfo;
    },
    getCart: async function(){
        let cart;
        const url = '/cart.json';

        await fetch(url)
        .then( response => response.json() )
        .then( response => {
            cart = response;
        });
        return cart;
    },	
    addItemCart: async function(variant_id, callback){
        const url = '/cart/add.js';
        const data = {
            id: variant_id,
            quantity: 1
        };			

        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            return true;
        })
        .catch((error) => { 
            console.error('Error:', error);
        });			
    },	
    getShippingRates: async function (zip, clear) {
        const zipInfo = await this.getZip(zip);
        const url = `/cart/shipping_rates.json?shipping_address[zip]=${ zipInfo.cep }&shipping_address[country]=Brazil&shipping_address[province]=${ zipInfo.state }`;

        await fetch(url)
        .then( response => response.json() )
        .then( response => {
            this.renderShippingRates(response.shipping_rates, zipInfo);
            
            if(clear !== undefined){
                fetch('/cart/clear.js', {})
                return true	
            }
        })
        .catch((error) => { 
            console.error('Error:', error);
        });				
        
    },
    showLoading: function(value){
        if(value){
            this.selectors.wrapperResponse.classList.add('loading');
        } else{
            this.selectors.wrapperResponse.classList.remove('loading');
        }
    },
    renderShippingRates: function(shippingRates, zipInfo) {
        this.showLoading(false);
        
        if(shippingRates !== undefined && shippingRates.length > 0){
            const listRates = document.createElement('ul');
            listRates.classList.add('response__rates');
            let template_li = '';
            for(item of shippingRates){

                var sourceName = '';

                if(item.source !== 'shopify' && item.source !== 'Frenet'){
                    sourceName = item.source; 
                }

                var deliveryDays = '';
                if(item.delivery_days[0] !== undefined){
                    var deliveryDays = `<span>Entrega em - ${ item.delivery_days[0] } dia(s) útil(eis)</span>`;
                }

                var localDelivery = '';
                if(item.name === 'Local Delivery'){
                    localDelivery = 'Entrega Local'; 
                }else{
                    localDelivery = item.name;
                }
                
                template_li += `
                    <li> 
                        <span>${ sourceName } ${ localDelivery } - ${ this.formatPrice(Number(item.price)) }</span>
                        ${ deliveryDays }
                    </li>				
                `
            }
            listRates.innerHTML = template_li;
            this.selectors.wrapper.querySelector('.shipping__response').append(listRates); 
            localStorage.setItem('freeShipingZipSaved', JSON.stringify(zipInfo));

            if(this.selectors.wrapper.closest('cart-drawer') !== null){
                Miramontes.freeShippingCalculator.init(zipInfo, this.selectors.wrapper, this.cart);

                const box = document.querySelectorAll('.cftDraw');
                box.forEach(box => { box.classList.remove("active"); });
            }
        } else {
            this.renderReponse('Nós não entregamos para esse endereço.');
        }
        
    },				
    renderReponse: function(message){
        this.selectors.wrapper.querySelector('.shipping__response').innerHTML = message;
    },
    formatPrice: function(price){
        return new Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(price);
    }
}